import React, { useEffect, useState } from 'react';
import { ACTION_CODE, callApp } from '../../utils/callApp';
import { PAGREE_CODE } from '../../utils/codeEnum';
import './index.css';

const PRE_ACTION = {
  RELOAD: 'reload'
}


let time:any = null;
let intervalTime = 1000;
function closePage(fn:Function){
  let interval = (+new Date()) - time;
  if(interval>1000){
    fn&&fn();
  }else{
    setTimeout(()=>{
      closePage(fn);
    },intervalTime - interval);
  }
}
let timer1:any=null;
let timer2:any=null;
const LoadingConfirm:React.FC<{data:any,onClose:Function}> = (props)=> {
  // setTimeout(()=>{
  //   props.onClose();
  // },2000)
  const [loadingState,setLoadingState] = useState(props.data.loadingState);
  
  // console.log(timer2,timer1,'23232')
  const onLoading1 = ()=>{
    timer1 = setTimeout(()=>{
      setLoadingState(2)
    },props.data.loading1Time||10000)
  }
  const onLoading2 = ()=>{
    timer2 = setTimeout(()=>{
      setLoadingState(3)
    },props.data.loading2Time||10000)
  }
  const clearTimer = ()=>{
    // console.log(timer2,timer1)
    timer2&&clearTimeout(timer2)
    timer1&&clearTimeout(timer1)
    timer2 = null;
    timer1 = null;
  }
  useEffect(()=>{
    if(loadingState==1){
      clearTimer();
      onLoading1()
    }else if(loadingState==2){
      clearTimer();
      onLoading2()
    }
  },[loadingState])
  useEffect(()=>{
    if(props.data.close){
      closePage(props.onClose)
    }else{
      time = +new Date();
    }
  },[props.data.close])

  useEffect(() => {
    return componentWillUnmount;
  }, []);

  function componentWillUnmount() {
    // 组件销毁时你要执行的代码
    console.log('=============销毁===========')
    clearTimer();
  }

  //展示状态
  const onClose = ()=>{
    //通知取消
    callApp(ACTION_CODE.POST_CONFIRM,{code:PAGREE_CODE.CANCEL})
    props.onClose();
  }
  const onSure = ()=>{
    callApp(ACTION_CODE.POST_CONFIRM,{code:PAGREE_CODE.SUCCESS})
    props.onClose();

    if (props.data.actionType && props.data.actionType === PRE_ACTION.RELOAD) {
      window.location.reload()
    }
  }
  return (
    <>
      <div className="wrap_border">
        {
          (loadingState==1||loadingState==2)&&<div className="loading_wrap">
            {loadingState==2&&<div className="loading_word">{props.data.loadingWord}</div>}
            <div className="loading_icon"></div>
          </div>
        }
        {
          loadingState==3&&<div className="confirm_wrap">
            <div className="titleC">{props.data.msg}</div>
            <div className="buttom_wrap">
              <div className="button_close" onClick={()=>{onClose()}}>{props.data.closeMsg||'取消'}</div>
              <div className="button_sure" onClick={()=>{onSure()}}>{props.data.sureMsg||'确认'}</div>
            </div>
          </div>
        }
        
      </div>
    </>
  );
}




export default LoadingConfirm;
